import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './country-of-birth.reducer';

export const CountryOfBirthDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const countryOfBirthEntity = useAppSelector(state => state.countryOfBirth.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="countryOfBirthDetailsHeading">
          <Translate contentKey="apiLocationApp.countryOfBirth.detail.title">CountryOfBirth</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.countryOfBirth.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.countryOfBirth.date">Date</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.countryOfBirth.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.countryOfBirth.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllUsualResidents">
              <Translate contentKey="apiLocationApp.countryOfBirth.totalAllUsualResidents">Total All Usual Residents</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.totalAllUsualResidents}</dd>
          <dt>
            <span id="ukTotal">
              <Translate contentKey="apiLocationApp.countryOfBirth.ukTotal">Uk Total</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.ukTotal}</dd>
          <dt>
            <span id="england">
              <Translate contentKey="apiLocationApp.countryOfBirth.england">England</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.england}</dd>
          <dt>
            <span id="northernIreland">
              <Translate contentKey="apiLocationApp.countryOfBirth.northernIreland">Northern Ireland</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.northernIreland}</dd>
          <dt>
            <span id="scotland">
              <Translate contentKey="apiLocationApp.countryOfBirth.scotland">Scotland</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.scotland}</dd>
          <dt>
            <span id="wales">
              <Translate contentKey="apiLocationApp.countryOfBirth.wales">Wales</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.wales}</dd>
          <dt>
            <span id="republicOfIreland">
              <Translate contentKey="apiLocationApp.countryOfBirth.republicOfIreland">Republic Of Ireland</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.republicOfIreland}</dd>
          <dt>
            <span id="otherEuCountries">
              <Translate contentKey="apiLocationApp.countryOfBirth.otherEuCountries">Other Eu Countries</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.otherEuCountries}</dd>
          <dt>
            <span id="africa">
              <Translate contentKey="apiLocationApp.countryOfBirth.africa">Africa</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.africa}</dd>
          <dt>
            <span id="middleEastAsia">
              <Translate contentKey="apiLocationApp.countryOfBirth.middleEastAsia">Middle East Asia</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.middleEastAsia}</dd>
          <dt>
            <span id="farEast">
              <Translate contentKey="apiLocationApp.countryOfBirth.farEast">Far East</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.farEast}</dd>
          <dt>
            <span id="theAmericas">
              <Translate contentKey="apiLocationApp.countryOfBirth.theAmericas">The Americas</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.theAmericas}</dd>
          <dt>
            <span id="antarcticaOceania">
              <Translate contentKey="apiLocationApp.countryOfBirth.antarcticaOceania">Antarctica Oceania</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.antarcticaOceania}</dd>
          <dt>
            <span id="otherCountries">
              <Translate contentKey="apiLocationApp.countryOfBirth.otherCountries">Other Countries</Translate>
            </span>
          </dt>
          <dd>{countryOfBirthEntity.otherCountries}</dd>
        </dl>
        <Button tag={Link} to="/country-of-birth" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/country-of-birth/${countryOfBirthEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CountryOfBirthDetail;
